
import store from '@/store'

const capitalize = (string) =>
  string.charAt(0).toUpperCase() + string.slice(1)

const toCamel = (s) => {
  return s.replace(/([-_][a-z])/ig, ($1) => {
    return $1.toUpperCase()
      .replace('-', '')
      .replace('_', '')
  })
}

const format = (s) => toCamel(capitalize(s))

const ALL_PERMISSIONS = [ 'view', 'change', 'add', 'delete' ]

/**
 * Generates app/model permission computed properties
 * @author Virgilio Vázquez J. <virgilio.vazquez@jbge.com.mx>
 * @example
 * <template>
 *  <div v-if="canViewZone">
 *    User can view zones
 *  </div>
 *  <div v-if="canChangeZone">
 *    User can change zones
 *  </div>
 * </template>
 * <script>
 * import { mapPermissions } from '@/utils'
 * export default {
 *   computed: {
 *     ...mapPermissions('zones', 'zone', [ 'view', 'change' ])
 *     // This will result in the computed properties
 *     // canViewZone, canChangeZone
 *   },
 *   data (): => ({}),
 * }
 * </script>
 *
 * @param  {String}              app         The app
 * @param  {String|Array|Object} model       The model
 * @param  {Array}               permissions  A list of permissions to extrack
 * @param  {Object}              opts        Mapping optios
 * @return {Object}                          An object with the computed properties
 */
const mapPermissions = (app, models, permissions = ALL_PERMISSIONS, opts = {}) => {
  let { prefix } = opts
  prefix = prefix || 'can'

  let modelMap = models

  if (typeof modelMap === 'string') {
    modelMap = [ modelMap ]
  }

  if (Array.isArray(modelMap)) {
    const newMap = {}
    modelMap.forEach(model => {
      newMap[model] = format(model)
    })
    modelMap = newMap
  }

  const obj = {}
  Object.entries(modelMap).forEach(([ model, mappedName ]) => {
    permissions.forEach(p => {
      const getter = () => {
        const appGetter = store.getters['account/modelPermission'](app, model)
        return !!appGetter[p]
      }
      obj[`${prefix}${format(p)}${mappedName}`] = getter
    })
  })

  return obj
}

export default mapPermissions



// WEBPACK FOOTER //
// ./src/plugins/accountPermissions/mapPermissions.js